// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1tGWy","notes":"Notes_notes__1IynM"};